import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=bdb0f95a&scoped=true&"
import script from "./MenuIcon.vue?vue&type=script&lang=js&"
export * from "./MenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./MenuIcon.vue?vue&type=style&index=0&id=bdb0f95a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb0f95a",
  null
  
)

export default component.exports